import { render, staticRenderFns } from "./PsinAddEditPpin.vue?vue&type=template&id=127b16c0&scoped=true&"
import script from "./PsinAddEditPpin.vue?vue&type=script&lang=js&"
export * from "./PsinAddEditPpin.vue?vue&type=script&lang=js&"
import style0 from "./PsinAddEditPpin.vue?vue&type=style&index=0&id=127b16c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127b16c0",
  null
  
)

export default component.exports